import { graphql, createFragmentContainer } from 'react-relay/legacy';
import PropTypes from 'prop-types';

import { BuyMobileNavRefineMenuFacet } from './BuyMobileNavRefineMenuFacet';
import { SbSharedRefineMenuRadioSelect } from '../../finding/SbSharedRefineMenu/SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect';
import { SORT } from '../../finding/SbSharedRefineMenu/sbSharedRefineMenuConstants';

const BuyMobuileRefineMenuSortByComponent = ({ itemSearch }) => {
    const { displayUriRef = '', sort = {} } = itemSearch;
    const currentOption = sort.currentOption || {};
    const sortOptions = sort.options || [];

    return (
        <BuyMobileNavRefineMenuFacet storageFacetKey={SORT} title="Sort By" initiallyExpanded>
            <SbSharedRefineMenuRadioSelect
                filterName={SORT}
                valuesToShow={sortOptions}
                displayUriRef={displayUriRef}
                canBeDismissed={false}
                appliedFilterValues={[currentOption]}
            />
        </BuyMobileNavRefineMenuFacet>
    );
};

BuyMobuileRefineMenuSortByComponent.propTypes = {
    itemSearch: PropTypes.shape({
        sort: PropTypes.object,
        displayUriRef: PropTypes.string,
    }),
};

export const BuyMobuileRefineMenuSortBy = createFragmentContainer(
    BuyMobuileRefineMenuSortByComponent,
    {
        itemSearch: graphql`
            fragment BuyMobuileRefineMenuSortBy_itemSearch on ItemSearchQueryConnection {
                displayUriRef
                sort {
                    options {
                        urlLabel
                        linkReference
                        displayName
                    }
                    currentOption {
                        urlLabel
                        displayName
                    }
                }
            }
        `,
    }
);
